/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Guarantee associated with a borrower contract loan
 * @export
 * @interface BorrowerContractGuaranteeDto
 */
export interface BorrowerContractGuaranteeDto {
    /**
     * Unique identifier of the product guarantee
     * @type {string}
     * @memberof BorrowerContractGuaranteeDto
     */
    id: string;
    /**
     * Guarantee code
     * @type {string}
     * @memberof BorrowerContractGuaranteeDto
     */
    code: string;
    /**
     * Full guarantee label
     * @type {string}
     * @memberof BorrowerContractGuaranteeDto
     */
    label?: string | null;
    /**
     * Short guarantee label
     * @type {string}
     * @memberof BorrowerContractGuaranteeDto
     */
    shortLabel?: string | null;
}

/**
 * Check if a given object implements the BorrowerContractGuaranteeDto interface.
 */
export function instanceOfBorrowerContractGuaranteeDto(value: object): value is BorrowerContractGuaranteeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function BorrowerContractGuaranteeDtoFromJSON(json: any): BorrowerContractGuaranteeDto {
    return BorrowerContractGuaranteeDtoFromJSONTyped(json, false);
}

export function BorrowerContractGuaranteeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerContractGuaranteeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'label': json['label'] == null ? undefined : json['label'],
        'shortLabel': json['shortLabel'] == null ? undefined : json['shortLabel'],
    };
}

export function BorrowerContractGuaranteeDtoToJSON(json: any): BorrowerContractGuaranteeDto {
    return BorrowerContractGuaranteeDtoToJSONTyped(json, false);
}

export function BorrowerContractGuaranteeDtoToJSONTyped(value?: BorrowerContractGuaranteeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'shortLabel': value['shortLabel'],
    };
}

